// src/pages/Wallet/components/TabSelector.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './TabSelector.css';

const TabSelector = ({ activeTab, onTabChange, tokenCount = 0, nftCount = 0 }) => {
  const { t } = useTranslation();
  
  const tabs = [
    {
      id: 'tokens',
      label: t('wallet.tabs.tokens', 'Tokens'),
      count: tokenCount
    },
    {
      id: 'nfts', 
      label: t('wallet.tabs.nfts', 'NFTs'),
      count: nftCount
    }
  ];
  
  return (
    <div className="tab-selector">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="tab-label">{tab.label}</span>
          {tab.count > 0 && (
            <span className="tab-count">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TabSelector;